import { isProviderQrUrl, useProviderInvoice } from '../../../api/hooks/delivery/useProviderInvoice';
import { Loading } from '../../../components/atoms/Loading';
import { DeliveryStatusGsisDoc } from './DeliveryStatusGsisDoc';

interface Props {
  qrUrl: string | undefined;
}

export const ProviderInvoiceDoc = ({ qrUrl }: Props) => {
  const { data, isLoading } = useProviderInvoice(qrUrl);

  if (!isProviderQrUrl(qrUrl)) return null;
  if (isLoading) return <Loading />;
  if (!data) return null;

  return (
    <div className="width-100 m-t-16 flex-center-center-column-nowrap">
      <DeliveryStatusGsisDoc doc={data} />
    </div>
  );
};
